// import React, { useEffect, useState } from "react";
// import { TextInput, TextArea, useForm } from "../Components/Inputs";
// import init_expense from "./init_expense";
// import Btn from "../../../Components/Buttons/Btn";
// import { useNavigate, useParams } from "react-router-dom";
// import useApp from "../../../Hooks/useApp";
// import useAxios from "../../../Hooks/useAxios";

// const Edit = () => {
//   const [input, setInput] = useState(init_expense);
//   const navigate = useNavigate();
//   const { user } = useApp();
//   const request = useAxios();
//   const { id } = useParams();

//   useEffect(() => {
//     getExpense();
//   }, []);

//   const getExpense = async () => {
//     const res = await request({
//       method: "GET",
//       url: "other-expenses/single-expense",
//       params: {
//         id: parseInt(id),
//       },
//       show_loading: false,
//     });

//     if (res === "error") return;

//     const updatedInput = {
//       name: { ...input.name, value: res?.name || "" },
//       amount: { ...input.amount, value: parseInt(res?.amount) || 0 },
//       description: { ...input.description, value: res?.description || "" },
//     };

//     setInput(updatedInput);
//   };

//   const handleSubmit = async (data) => {
//     const res = await request({
//       method: "PUT",
//       url: "other-expenses/update",
//       body: {
//         id: parseInt(id),
//         ...data,
//       },
//     });

//     if (res !== "error") {
//       navigate("/dashboard/expenses");
//     }
//   };

//   const { handleValidation, validate } = useForm({
//     input,
//     submit: handleSubmit,
//   });

//   return (
//     <div className="w-4/5 max-md:w-full mx-auto bg-white shadow-md rounded-lg mt-8 p-5 border-t">
//       <h3 className="text-primary text-center mt-5 font-semibold text-xl mb-4">
//         Edit Expense
//       </h3>
//       <div className="flex gap-6 max-md:flex-col max-md:w-full">
//         <TextInput input={input} setInput={setInput} field="name" />
//         <TextInput input={input} setInput={setInput} field="amount" />
//       </div>
//       <div className="flex w-full">
//         <TextArea input={input} setInput={setInput} field="description" />
//       </div>
//       <div className="flex justify-between items-center">
//         <Btn onClick={() => navigate("/dashboard/expenses")}>Cancel</Btn>
//         <Btn onClick={handleValidation}>Update</Btn>
//       </div>
//     </div>
//   );
// };

// export default Edit;

import React, { useEffect, useState } from "react";
import { TextInput, TextArea, useForm } from "../Components/Inputs";
import init_expense from "./init_expense";
import Btn from "../../../Components/Buttons/Btn";
import { useNavigate, useParams } from "react-router-dom";
import useApp from "../../../Hooks/useApp";
import useAxios from "../../../Hooks/useAxios";

const Edit = () => {
  const [input, setInput] = useState(init_expense);
  const navigate = useNavigate();
  const { user } = useApp();
  const request = useAxios();
  const { id } = useParams();

  useEffect(() => {
    getExpense();
  }, []);

  const getExpense = async () => {
    const res = await request({
      method: "GET",
      url: "other-expenses/single-expense",
      params: {
        id: parseInt(id),
      },
      show_loading: false,
    });

    if (res === "error") return;

    const updatedInput = {
      name: { ...input.name, value: res?.name || "" },
      amount: { ...input.amount, value: parseInt(res?.amount) || 0 },
      description: { ...input.description, value: res?.description || "" },
    };

    setInput(updatedInput);
  };

  const handleSubmit = async () => {
    const payload = {
      id: parseInt(id),
      name: input.name.value,
      amount: parseInt(input.amount.value),
      description: input.description.value,
      // updated_at: new Date().toISOString(),
    };

    const res = await request({
      method: "PUT",
      url: "other-expenses/update",
      body: payload,
    });

    if (res !== "error") {
      navigate("/dashboard/expenses");
    }
  };

  const { handleValidation } = useForm({
    input,
    submit: handleSubmit,
  });

  return (
    <div className="w-4/5 max-md:w-full mx-auto bg-white shadow-md rounded-lg mt-8 p-5 border-t">
      <h3 className="text-primary text-center mt-5 font-semibold text-xl mb-4">
        Edit Expense
      </h3>
      <div className="flex gap-6 max-md:flex-col max-md:w-full">
        <TextInput input={input} setInput={setInput} field="name" />
        <TextInput input={input} setInput={setInput} field="amount" />
      </div>
      <div className="flex w-full">
        <TextArea input={input} setInput={setInput} field="description" />
      </div>
      <div className="flex justify-between items-center">
        <Btn onClick={() => navigate("/dashboard/expenses")}>Cancel</Btn>
        <Btn onClick={handleValidation}>Update</Btn>
      </div>
    </div>
  );
};

export default Edit;
